import { i18n } from '@/plugins/i18n'

export default {
    orderItem: {
        PENDING: 1,
        DELIVERED: 2,
        NOT_DELIVERED: 3,
        REJECTED: 4
    },
    getOrderItemStatus(itemData) {
        switch (itemData) {
            case 4:
                return i18n.t('orderStatus.rejected')
            case 2:
                return i18n.t('orderStatus.delivered')
            case 3:
                return i18n.t('orderStatus.not-delivered')
            case 1:
                return i18n.t('orderStatus.pending')
        }
    },
    orderVisible(orderStatus) {
        return (orderStatus === 1 || orderStatus === 2 || orderStatus === 3)
    },
    orderEditable(orderStatus) {
        return (orderStatus === 1 || orderStatus === 3)
    }
}
